import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

// Legge preferenze per utente specifico dal localStorage
const getUserPrefs = (userId) => {
  try {
    const key = `prefs_${userId || 'guest'}`;
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : null;
  } catch { return null; }
};

const saveUserPrefs = (userId, prefs) => {
  try {
    const key = `prefs_${userId || 'guest'}`;
    localStorage.setItem(key, JSON.stringify(prefs));
  } catch {}
};

const DEFAULTS = { theme: 'light', fontSize: 'medium', compactMode: false };

export const ThemeProvider = ({ children, userId }) => {
  const [prefs, setPrefs] = useState(() => {
    const saved = getUserPrefs(userId);
    return { ...DEFAULTS, ...saved };
  });

  // Quando cambia userId (login/logout) ricarica le preferenze
  useEffect(() => {
    const saved = getUserPrefs(userId);
    const merged = { ...DEFAULTS, ...saved };
    setPrefs(merged);
    applyToDOM(merged);
  }, [userId]);

  const applyToDOM = (p) => {
    document.documentElement.setAttribute('data-theme', 'light'); // tema unico, ignorate le vecchie preferenze 'dark'
    document.documentElement.setAttribute('data-fontsize', p.fontSize);
    document.documentElement.setAttribute('data-compact', p.compactMode ? 'true' : 'false');
  };

  useEffect(() => { applyToDOM(prefs); }, [prefs]);

  const update = (key, value) => {
    setPrefs(prev => {
      const next = { ...prev, [key]: value };
      saveUserPrefs(userId, next);
      return next;
    });
  };

  const reset = () => {
    setPrefs(DEFAULTS);
    saveUserPrefs(userId, DEFAULTS);
  };

  return (
    <ThemeContext.Provider value={{ prefs, update, reset }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
